export const imgUrl = process.env.REACT_APP_IMAGE_URL;
export const url = process.env.REACT_APP_BASE_URL;
